import { Page } from '@app/components/page/Page';
import { SocialExportBreadcrumbs } from '@app/modules/social-export/components/breadcrumbs/SocialExportBreadcrumbs';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { StationsState } from './StationsState';

interface Props {
  platform: SocialPlatform;
}

export const SocialExportManagePage = (p: Props) => {
  const { formatMessage, $t } = useIntl();

  const title = formatMessage(
    {
      id: 'admin.socialExport.title',
      defaultMessage: 'Integración con {name}',
    },
    { name: p.platform.name },
  );

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={p.platform.Icon()}
        title={title}
        breadcrumbs={<SocialExportBreadcrumbs />}
        actions={
          <div>
            <Button
              component={Link}
              to={`/admin/social-export/uploaded/${p.platform.id}`}
              startIcon={<CloudUploadIcon />}
            >
              {$t({
                id: 'socialExport.viewLastPublishedVideos',
                defaultMessage: 'Ver últimos videos publicados',
              })}
            </Button>
          </div>
        }
      />
      <Page.Content>
        <StationsState platform={p.platform} />
      </Page.Content>
    </Page>
  );
};
